import React, { useEffect, useState } from "react";
import moment from "moment";
import useHttp from "../../../hooks/use-http";
import { Column, Pie, Line } from "@ant-design/plots";

const RevenueDashboard = () => {
  const [count, setCount] = useState([]);
  const [data, setData] = useState();

  const handleFDateChange = (e) => {
    setSelectedFromDate(e.target.value);
  };
  const handleTDateChange = (e) => {
    setSelectedToDate(e.target.value);
  };

  const currentDate = new Date().toISOString().slice(0, 10);
  var d = new Date();
  d.setDate(d.getDate() - 365);

  const fromDate = d.toISOString().slice(0, 10);
  const [selectedFromDate, setSelectedFromDate] = useState();

  const toDate = new Date().toISOString().slice(0, 10);

  //console.log("toDate", toDate);

  const [selectedToDate, setSelectedToDate] = useState();

  const { sendRequest: getData } = useHttp();

  const { sendRequest: getCount } = useHttp();

  const fillData = () => {
    var urlfilter = "";

    var fdate = moment(selectedFromDate).format("DD/MM/YYYY");
    var tdate = moment(selectedToDate).format("DD/MM/YYYY");

    if (selectedFromDate && selectedToDate) {
      urlfilter = urlfilter + `&fromDate=${fdate}`;
      urlfilter = urlfilter + `&toDate=${tdate}`;
    }

    var url = `/api/dashboard_revenue_analysis/?orgId=${localStorage.getItem(
      "orgId"
    )}${urlfilter} `;

    getData(
      {
        url: url,
      },
      (data) => {
        console.log("reportdata", data.revenueMonthwise);
        setData(data);
      }
    );

    var url1 = `/api/dashboard_analysis/?orgId=${localStorage.getItem(
      "orgId"
    )}${urlfilter} `;

    getCount(
      {
        url: url1,
      },
      (res) => {
        console.log("count Data", res);
        setCount(res);
      }
    );
  };

  useEffect(() => {
    fillData();
  }, [getData]);

  useEffect(() => {}, [data]);

  const CustomerwisePieConfig = {
    appendPadding: 10,
    data: data && data.revenueCustomerwise,
    angleField: "total_revenue",
    colorField: "customer_name",
    radius: 0.75,
    label: {
      type: "spider",
      labelHeight: 28,
      content: "{name}\n{percentage}",
    },
    interactions: [
      {
        type: "element-selected",
      },
      {
        type: "element-active",
      },
    ],
    meta: {
      total_revenue: {
        alias: "Total Revenue",
      },
    }
  };

  const modifiedData = data &&data.revenueMonthwise.map(item => ({
    ...item,
    month_year: `${item.month_name} ${item.year}`,
  }));

  const monthwiseConfig = {
    data: data && modifiedData,
    padding: "10",
    xField: "month_year",
    yField: "total_revenue",
    xAxis: {
      tickCount: 3,
      label: {
        formatter: (text, item, index) => {
          const date = new Date(text);
          const month = date.toLocaleString('default', { month: 'short' });
          const year = date.getFullYear().toString().slice(-2);
          return `${month} ${year}`;
        },
      },
    },
    meta: {
      total_revenue: {
        alias: "Total Revenue",
      },
    }
    
  };

  const productwiseConfig = {
    data: data && data.revenueProductwise,
    xField: "product_name",
    yField: "total_revenue",
    label: {
      position: "middle",

      style: {
        fill: "#FFFFFF",
        opacity: 0.6,
      },
    },
    xAxis: {
      label: {
        // autoHide: true,
        autoRotate: false,
        rotate: 220,
      },
      title: {
        text: "Product Name",
      },
    },
    yAxis: {
      title: {
        text: "Revenue ",
      },
    },
    scrollbar: {
      type: "horizontal",
    },
    meta: {
      total_revenue: {
        alias: "Revenue",
      },
      product_name: {
        alias: "Product Name",
      },
    },
  };

  const CropwiseConfig = {
    data: data && data.revenueCropwise,
    xField: "cropName",
    yField: "totalAmount",
    label: {
      position: "middle",

      style: {
        fill: "#FFFFFF",
        opacity: 0.6,
      },
    },
    xAxis: {
      label: {
        // autoHide: true,
        autoRotate: false,
        rotate: 220,
      },
      title: {
        text: "Crop Name",
      },
    },
    yAxis: {
      title: {
        text: "Total Amount ",
      },
    },
    scrollbar: {
      type: "horizontal",
    },
    meta: {
      totalAmount: {
        alias: "Total Amount",
      },
      cropName: {
        alias: "crop Name",
      },
    },
  };

  return (
    <>
      <div className="content-wrapper">
        <div className="content-header">
          <div className="container-fluid">
            <div className="row mb-2">
              <div className="col-sm-6">
                <label className="m-0 card-title">Revenue Dashboard</label>
              </div>
            </div>
            <div className="row">
              <div className="col-md-2">
                <div className="form-group">
                  {" "}
                  <label htmlFor={"from_date"}>{"From Date"}</label>
                  <input
                    type={"date"}
                    id={"date"}
                    required
                    className="form-control"
                    max={currentDate}
                    value={selectedFromDate}
                    onChange={handleFDateChange}
                  />
                </div>
              </div>
              <div className="col-md-2">
                <div className="form-group">
                  <label htmlFor={"to_date"}>{"To Date"}</label>

                  <input
                    type={"date"}
                    id={"date"}
                    required
                    className="form-control"
                    min={selectedFromDate}
                    value={selectedToDate}
                    onChange={handleTDateChange}
                  />
                </div>
              </div>
              <div className="col-md-2">
                <div className="form-group">
                  <label>&nbsp;</label>
                  <button
                    className="form-control btn btn-sm btn-primary"
                    onClick={(e) => {
                      fillData();
                    }}
                  >
                    Submit
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
        <section className="content">
          <div className="container-fluid">
            <div className="row">
              <div className="col-md-3 col-sm-6 col-12">
                <div className="info-box">
                  <span className="info-box-icon bg-info">
                    <i className="fas fa-regular fa-user"></i>
                  </span>
                  <div className="info-box-content">
                    <span className="info-box-text">Customers</span>
                    <span className="info-box-number">
                      {count && count.totalCustomers}
                    </span>
                  </div>
                  {/* /.info-box-content */}
                </div>
                {/* /.info-box */}
              </div>
              {/* /.col */}
              <div className="col-md-3 col-sm-6 col-12">
                <div className="info-box">
                  <span className="info-box-icon bg-success">
                    <i className="far fa-flag" />
                  </span>
                  <div className="info-box-content">
                    <span className="info-box-text">Products</span>
                    <span className="info-box-number">
                      {count && count.totalProducts}
                    </span>
                  </div>
                  {/* /.info-box-content */}
                </div>
                {/* /.info-box */}
              </div>
              {/* /.col */}
              <div className="col-md-3 col-sm-6 col-12">
                <div className="info-box">
                  <span className="info-box-icon bg-warning">
                    <i className="fas fa-solid fa-receipt"></i>
                  </span>
                  <div className="info-box-content">
                    <span className="info-box-text">Sales Invoices</span>
                    <span className="info-box-number">
                      {count && count.totalInvoices}
                    </span>
                  </div>
                  {/* /.info-box-content */}
                </div>
                {/* /.info-box */}
              </div>
              {/* /.col */}
              <div className="col-md-3 col-sm-6 col-12">
                <div className="info-box">
                  <span className="info-box-icon bg-danger">
                    <i className=" fas fa-light fa-dollar-sign"></i>
                  </span>
                  <div className="info-box-content">
                    <span className="info-box-text">Revenue</span>
                    <span className="info-box-number">
                      {count && count.totalRevenue}
                    </span>
                  </div>
                  {/* /.info-box-content */}
                </div>
                {/* /.info-box */}
              </div>
              {/* /.col */}
            </div>
          </div>
        </section>

        <div className="content">
          <div className="container-fluid">
            <div className="row">
              <div className="col-md-6">
                <div className="card card-primary shadow">
                  <div className="card-header">
                    <h3 className="card-title">Monthwise Revenue</h3>

                    <div className="card-tools">
                      <button
                        type="button"
                        className="btn btn-tool"
                        data-card-widget="maximize"
                      >
                        <i className="fas fa-expand"></i>
                      </button>
                    </div>
                  </div>

                  <div className="card-body">
                    <div>&nbsp;</div>

                    {data && (
                      <div style={{ width: "80%" }}>
                        &nbsp; <Line {...monthwiseConfig} />
                      </div>
                    )}
                  </div>
                </div>
              </div>

              <div className="col-md-6">
                <div className="card card-primary shadow">
                  <div className="card-header">
                    <h3 className="card-title">Customerwise Revenue</h3>

                    <div className="card-tools">
                      <button
                        type="button"
                        className="btn btn-tool"
                        data-card-widget="maximize"
                      >
                        <i className="fas fa-expand"></i>
                      </button>
                    </div>
                  </div>

                  <div className="card-body">
                    <div>&nbsp;</div>

                    {data && (
                      <div style={{ width: "80%" }}>
                        &nbsp;
                        <Pie {...CustomerwisePieConfig} />
                      </div>
                    )}
                  </div>
                </div>
              </div>
            </div>
            <div className="row">
              <div className="col-md-6">
                <div className="card card-primary shadow">
                  <div className="card-header">
                    <h3 className="card-title">Productwise Revenue</h3>

                    <div className="card-tools">
                      <button
                        type="button"
                        className="btn btn-tool"
                        data-card-widget="maximize"
                      >
                        <i className="fas fa-expand"></i>
                      </button>
                    </div>
                  </div>

                  <div className="card-body">
                    <div>&nbsp;</div>

                    {data && (
                      <div style={{ width: "80%" }}>
                        &nbsp;
                        <Column {...productwiseConfig} />
                      </div>
                    )}
                  </div>
                </div>
              </div>
              <div className="col-md-6">
                <div className="card card-primary shadow">
                  <div className="card-header">
                    <h3 className="card-title">Cropwise Revenue</h3>

                    <div className="card-tools">
                      <button
                        type="button"
                        className="btn btn-tool"
                        data-card-widget="maximize"
                      >
                        <i className="fas fa-expand"></i>
                      </button>
                    </div>
                  </div>

                  <div className="card-body">
                    <div>&nbsp;</div>

                    {data && (
                      <div style={{ width: "80%" }}>
                        &nbsp;
                        <Column {...CropwiseConfig} />
                      </div>
                    )}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default RevenueDashboard;
